import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { FACILITY_HAZAR_WASTE_ATTACHMENT_API } from './config';

export function getList(query) {
  return getFetch(`${FACILITY_HAZAR_WASTE_ATTACHMENT_API()}`, query);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${FACILITY_HAZAR_WASTE_ATTACHMENT_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${FACILITY_HAZAR_WASTE_ATTACHMENT_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${FACILITY_HAZAR_WASTE_ATTACHMENT_API()}`, obj);
}



// WEBPACK FOOTER //
// ./src/api/facilityHazarWasteAttachmentApi.js